import { render, staticRenderFns } from "./fenceAlarm.vue?vue&type=template&id=01889630&scoped=true"
import script from "./fenceAlarm.vue?vue&type=script&lang=js"
export * from "./fenceAlarm.vue?vue&type=script&lang=js"
import style0 from "./fenceAlarm.vue?vue&type=style&index=0&id=01889630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01889630",
  null
  
)

export default component.exports